<template>
  <v-container
    id="start"
    fill-height
    class="d-flex flex-column justify-center"
  >
    <v-scroll-y-transition>
      <signed-feedback
        v-if="routeSigned"
      />
      <login
        v-else-if="((installed||pwa)||passwordRecovery||routeTos||routePrivacy||routeCancel)||dev"
        :installed="installed"
        :pwa="pwa"
        :show="show"
        :modal="modal"
        :password-recovery="passwordRecovery"
        :start="start"
        :route="route"
        :route-tos="routeTos"
        :route-privacy="routePrivacy"
        :route-cancel="routeCancel"
        @logged-in="onLogin"
      />
      <install
        v-else
        :installed="installed"
        :pwa="pwa"
      />
    </v-scroll-y-transition>

    <toast />
  </v-container>
</template>

<style>

  #start {
    padding: 0;
    width: 100%;
    /* background: var(--driver-bg) !important; */
  }
  @media (min-width: 600px) and (orientation: landscape) {
    #start {
      width: 360px;
      max-height: 640px;
      margin: 4rem auto;
      border-radius: 1rem;
      border: 1px solid var(--v-secondary-darken3);
    }
  }


</style>

<script>

  // Icons
  import {
    mdiHelpCircleOutline,
    mdiEye,
    mdiEyeOff,
    mdiClose
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { get, sync } from 'vuex-pathify'
  import device from '@/device';


  export default {
    name: 'Start',

    props: {
      installed: {
        type: Boolean,
        default: false
      },
      modal: {
        type: String,
        default: null
      },
      dev: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiHelpCircleOutline,
        mdiEye,
        mdiEyeOff,
        mdiClose,
      },
      ios: device.isIOS,
      show: false,
    }),

    computed: {
      // views: sync('login/views'),
      // help: sync('app/views@help'),
      // help_sections: sync('help/sections'),
      status: get('user/status'),
      auth: get('user/auth'),
      toast: sync('app/toast'),

      pwa () {
        return device.isIOS && navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
      },

      passwordRecovery () {
        const a = this.getRecoveryCode() !== null ? true : false;
        const b = this.getRecoveryUsername() !== null ? true : false;
        return a&&b ? true : false;
      },

      start () {
        // is start page
        const start = !['login', 'register'].includes(this.route);
        return start;
      },

      route () {
        // is start page
        const route = this.$route.params.route;
        return route;
      },

      routeLogin () {
        // check route to login
        return this.$route.path.includes('/login');
      },
      
      routeTos () {
        // check route to TOS direct
        return this.$route.path.includes('/tos');
      },

      routePrivacy () {
        // check route to TOS direct
        return this.$route.path.includes('/privacy');
      },

      routeCancel () {
        // check route to cancel account direct
        return this.$route.path.includes('/cancel');
      },

      routeSigned () {
        // check route to cancel account direct
        return this.$route.path.includes('/termo-assinado');
      },
    },

    methods: {
      ...services,

      getRecoveryCode () {
        // get recovery code if present
        return typeof this.$route.params.code!=='undefined' ? this.$route.params.code : null
      },
      getRecoveryUsername () {
        // get recovery username if present
        return typeof this.$route.params.username!=='undefined' ? this.$route.params.username : null
      },

      // checkNative () {
      //   this.toggleToast(
      //     true,
      //     'mobees: '+ typeof mobees,
      //     1000
      //   );
      //   console.log('mobees: '+ typeof mobees);
      //   if (typeof mobees == 'undefined') {
      //     setTimeout(this.checkNative, 1000);
      //   }
      // },

      onLogin (user) {
        this.$emit('logged-in', user);
      },
    },

    mounted () {
      this.show = true;
      this.cancelToasts();
    },

    components: {
      Login: () => import('@/views/login/Login'),
      Install: () => import('@/views/login/Install'),
      SignedFeedback: () => import('@/components/SignedFeedback'),
      Toast: () => import('@/components/Toast'),
    },

  }
</script>
